/**
 * 
 * @file Preview loading and error UI wrapper
 * @author Box
 */

import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import IconFileDefault from 'box-react-ui/lib/icons/file/IconFileDefault';
import makeLoadable from 'box-react-ui/lib/components/loading-indicator/makeLoadable';
import messages from '../messages';


var PreviewLoading = function PreviewLoading() {
    return React.createElement(
        'div',
        { className: 'bcpr-loading' },
        React.createElement(IconFileDefault, { height: 160, width: 160 }),
        React.createElement(
            'div',
            { className: 'bcpr-loading-text' },
            React.createElement(FormattedMessage, messages.previewError)
        )
    );
};

export { PreviewLoading as PreviewLoadingComponent };
export default makeLoadable(PreviewLoading);